<template>
  <div class="indexCont">
    <div class="mainCont">
      <div class="btnArr">
        <span @click="goPage('./trainRecord')">
            <img src="../../../assets/images/common/video1.png" alt="">
            培训记录
        </span>
        <span>
            <img src="../../../assets/images/common/record2.png" alt="">
            <div>考试记录</div>
        </span>
        <span class="certificateList" @click="goPage('./certificateList')">
            <img src="../../../assets/images/common/list_1.png" alt="">
            证书列表
        </span>
        <el-button class="rank" type="primary" size="medium" @click="$router.push('./trainRank')">排行榜</el-button>
      </div>
      <div class="comSearch">
        <div>
          <span>请选择分类：</span>
          <el-autocomplete
            v-model="state"
            class="inline-input"
            :fetch-suggestions="querySearch"
            placeholder="请选择分类"
            @select="handleSelect"
            clearable
            @clear="demo()">
          </el-autocomplete>
        </div>
        <div class="txtTotal">
          <div><img src="../../../assets/images/home/a.png" alt="">考试时长：{{paperTotalTime}}分钟</div>
          <div><img src="../../../assets/images/home/d.png" alt="">考试次数：<span>{{paperTotalCount}}次</span></div>
          <div><img src="../../../assets/images/home/c.png" alt="">证书个数：{{certTotalCount}}个</div>
        </div>
      </div>
      <div class="testCont">
        <el-table
          :data="dataList"
          stripe
          style="width: 100%"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-text="拼命加载中"
        >
          <el-table-column prop="paperName" align="center" label="试卷名称" ></el-table-column>
          <el-table-column prop="parentCategoryName" align="center" label="一级分类"></el-table-column>
          <el-table-column prop="childCategoryName" align="center" label="二级分类"></el-table-column>
          <el-table-column prop="lastPaperTime" align="center" label="最近考试时间"></el-table-column>
          <el-table-column prop="maxFraction" align="center" label="考试最高分"></el-table-column>
          <el-table-column prop="paperCount" align="center" label="考试次数"></el-table-column>
          <el-table-column prop="paperTotalTime" align="center" label="考试总时长(分钟)"></el-table-column>
          <el-table-column align="center" label="考试证书">
            <template slot-scope="scope">
              <!-- scope.row：代表这一行数据的对象 -->
              <span class="testDetail" v-show="scope.row.userPaperCertList" @click="downloadCert(scope.row)">
                显示证书
              </span>
              <span class="testDetail" v-show="!scope.row.userPaperCertList">
                暂无
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="dataInfo.total"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>
    <!-- 移动端显示 -->
    <div class="mobileTest">
      <MobileComNav title="学习成就" url="./index"></MobileComNav>
      <div class="switchTest">
        <div @click="goPage('./trainRecord')">培训记录</div>
        <div class="active">考试记录</div>
        <div @click="goPage('./certificateList')">证书列表</div>
        <div @click="goPage('./trainRank')">排行榜</div>
      </div>
      <div class="mt_cont" v-show="!isShow">
        <div class="mobileSearch">
          <div>
            <span>请选择分类：</span>
            <el-autocomplete
              v-model="state"
              class="inline-input"
              :fetch-suggestions="querySearch"
              placeholder="请选择分类"
              @select="handleSelect"
              clearable
              @clear="demo()">
            </el-autocomplete>
          </div>
          <div class="mobileTxtTotal">
            <div><img src="../../../assets/images/home/a.png" alt=""> {{paperTotalTime}}分钟</div>
            <div><img src="../../../assets/images/home/d.png" alt=""> <span>{{paperTotalCount}}次</span></div>
            <div><img src="../../../assets/images/home/c.png" alt=""> {{certTotalCount}}个</div>
          </div>
        </div>
        <div class="mt_item" v-for="(item,index) in dataList" :key="index">
          <div class="title">{{item.paperName}}</div>
          <div class="time">最近考试时间：{{item.lastPaperTime}}</div>
          <div class="status">
            考试最高分：
            <span class="addColor">{{item.maxFraction}}分</span>
          </div>
          <div>考试次数：{{item.paperCount}}</div>
          <div>考试总时长：{{item.paperTotalTime}}分钟</div>
          <div class="btn" v-show="item.certStatus" @click="downloadCert(item)">显示证书</div>
          <div class="btn gayBtn" v-show="!item.certStatus">暂无证书</div>
        </div>
      </div>
      <div class="comTxt" v-show="isShow">暂无数据</div>
    </div>
    <!-- 证书 -->
    <el-dialog
        :visible.sync="DialogVisibleCert"
        :width="certDialogWidth"
        :close-on-press-escape="false"
        center>
        <div class="certPic">
            <!-- <img src="../../../assets/images/common/certPic.jpg" alt="" v-if="isShowCetrtPic"> -->
            <!-- <img src="$config.baseApi + /uploads/examination/2023/2/6/6cdd586042984861a1297d490b55df32.jpg" alt=""> -->
            <!-- <div class="cert_txt">
                <div class="username">{{username}}</div>
                <div class="certCode">编号No：{{certCode}}</div>
                <div class="time">日期Date：{{certTime}}</div>
            </div> -->
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide class="swiper-slide" v-for="(item,index) in swiperList" :key="index"
                >
                    <img :src="url + item.picture"/>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <div class="swiper-button-prev" slot="button-prev">
            </div>
            <div class="swiper-button-next" slot="button-next">
            </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import "swiper/css/swiper.min.css";
import MobileComNav from "../../../components/mobileHead";
export default {
  data() {
    return {
        url:this.$config.baseApi,
        loading: true,
        dataInfo:{},
        dataList:[],
        curPage: 1,
        isShow:false,
        pageSize:10,
        alreadyTotal:"",
        DialogVisibleCert:false,
        isShowCetrtPic:true,
        username:"",
        certCode:"",
        certTime:"",
        certPic:"",
        certDialogWidth:"5rem",
        certTotalCount:0,
        paperTotalCount:0,
        paperTotalTime:0,
        selectCont:[],
        state:"",
        swiperList:[],
        swiperOption: {
            loop: false, //是否循环轮播
            slidesPerView: 1,
            //左右切换
            navigation: {
               nextEl: ".swiper-button-next",
               prevEl: ".swiper-button-prev",
            },
        },
    };
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  components: {
    MobileComNav
  },
  created() {
    if(this.$IsPc()){
      this.pageSize = 10000;
      this.certDialogWidth = "6rem"
    };
    this.paperList();
    this.paperTotal();
    this.paperList2()
  },
  methods: {
    goPage(url) {
      this.$router.push(url);
    },
    paperList(categoryId) {
      let url = this.$config.baseApi + "/account/wx/paper/center";
      this.$ajax({
        url: url,
        method: "post",
        data: JSON.stringify({
          categoryId:categoryId,
          current:this.curPage,
          pageSize:this.pageSize
        })
      })
        .then(res => {
          if (res.code == 1) {
            this.dataList = res.data.records;
            if(res.data.total == 0){
              this.isShow = true
            }
            this.dataInfo = res.data;
            this.loading = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
     //获取分类
    paperList2() {
      let url = this.$config.baseApi + "/account/wx/paper/center";
      this.$ajax({
        url: url,
        method: "post",
        data: JSON.stringify({
          categoryId:"", 
          current:this.curPage,
          pageSize:10000
        })
      })
        .then(res => {
          if (res.code == 1) {
            let arr = res.data.records;
            for(var i=0; i<arr.length; i++){
                for(var j=i+1; j<arr.length; j++){
                    if(arr[i].parentCategoryName == arr[j].parentCategoryName){         //第一个等同于第二个，splice方法删除第二个
                        arr.splice(j,1);
                        j--;
                    }
                }
            }
            this.selectCont = arr
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
     // 搜索框
    querySearch(queryString, cb) {
      for(let i in this.selectCont){
          this.selectCont[i].value = this.selectCont[i].parentCategoryName
      }
      cb(this.selectCont)
    },
    handleSelect(item) {
      this.paperList(item.parentCategoryId);
    },
    demo(){
      this.paperList();
    },
    // 分页改变
    changePage(pageIndex) {
      this.curPage = pageIndex;
      this.paperList();
    },
    // 证书下载
    downloadCert(certVo){
      this.DialogVisibleCert=true
      // this.username = certVo.username;
      // this.certCode = certVo.certCode;
      // this.certTime = certVo.createTime.slice(0,10);
      // let certPic = certVo.certPic;
      if(certVo.userPaperCertList.length>0){
        this.swiperList = certVo.userPaperCertList
        console.log(this.swiperList);
        // this.certPic = certPic
        this.isShowCetrtPic = false
      }
    },
    paperTotal() {
      let url = this.$config.baseApi + "/account/wx/paper/total";
      this.$ajax({
        url: url,
        method: "post",
      }).then(res => {
        if(res.code == 1){
          this.certTotalCount = res.data.certTotalCount;
          this.paperTotalCount = res.data.paperTotalCount;
          this.paperTotalTime = res.data.paperTotalTime;
        }else{
          this.$message({
            message:res.data.msg,
            type:'error'
          })
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/home/test.css";
.mainCont {
  background: #fff;
  padding: 0.23rem 0.2rem;
  margin-bottom: 0.2rem;
}
.gayBtn{
  background:#909399;
}
.btnArr{
    border-bottom: 1px solid #e8e8e8;
    position: relative;
}
.btnArr .rank{
  position: absolute;
  top:0;
  right:0;
}
.btnArr span{
    display: inline-block;
    height: 0.42rem;
    width:1.2rem;
    line-height: 0.42rem;
    text-align: center;
    cursor: pointer;
}
.btnArr span img{
    height: 0.15rem;
}
.btnArr span:nth-child(2){
    position: relative;
}
.btnArr span:nth-child(2) div{
    margin-left:0.15rem;
}
.btnArr span:nth-child(2) img{
    height: 0.16rem;
    position: absolute;
    top: 0.13rem;
    left: 0.14rem;
}
.btnArr span:nth-child(2){
    border-bottom:0.03rem solid #417ccb;
    color:#417ccb;
    margin-right:0.1rem;
}
.txtTotal{
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #417ccb;
}
.txtTotal div{
  margin-left:0.2rem;
  font-size:0.16rem;
  display: flex;
  align-items: center;
}
.txtTotal div img{
  display:block;
  height: 0.2rem;
  margin-right:0.04rem;
}
.comSearch{
  margin-top:0.2rem;
}
.certPic {
  height: 5.5rem;
}
.certificateList img{
    vertical-align: middle;
    margin-top: -.03rem;
}
.swiper-container {
    height: 5rem;
    width: 3.5rem!important;
}
.swiper-slide {
    text-align: center;
    width: 3.5rem!important;
    height: 5rem!important;
}
.swiper-slide img{
    width: 3.5rem;
    height: 5rem;
}
.swiper-button-prev:after, .swiper-button-next:after {
    font-size: .4rem;
}
@media screen and (max-width: 768px) {
  .mainCont {
    display: none;
  }
  .mobileTest {
    display: block;
  }
  .comSearch{
    display: block;
    margin-top:0.2rem;
  }
  .mobileSearch{
      padding:0.2rem 5%;
      background:#fff;
      border-radius: 4px;
      margin-top:0.2rem;
  }
  .mobileSearch .el-autocomplete{
      width: 67%;
  }
  .mobileTxtTotal{
    margin-top:0.2rem;
    font-size:0.28rem;
    display:flex;
    justify-content: space-between;
    color:#417ccb;
  }
  .mobileTxtTotal div{
    margin:0.1rem 0;
    display: flex;
    align-items: center;
  }
  .mobileTxtTotal div img{
    display:block;
    height: 0.4rem;
    margin-right:0.15rem;
  }
}
</style>
